export enum ApiAdminProductStore{
    GET_PRODUCT_BY_ID ="store/admin/product/",
    OPTION_VARIANT_SUGGESTIONS="/store/admin/product/options-variant/suggestions",
    PRODUCT_SUGGEST="store/admin/product/suggestions",
    PRODUCTS_SEARCH ="store/admin/products/search",

    CREATE_PRODUCT_V2 = "store/admin/v2/product",
    UPDATE_PRODUCT_V2 = "store/admin/v2/product",
    GET_PRODUCT_BY_ID_V2 ="store/admin/v2/product/",
    PRODUCTS_SEARCH_V2 ="store/admin/v2/products/search",
    UPDATE_PRODUCT_STATUS_V2 = "store/admin/v2/product/",
    BULK_UPDATE_PRODUCT_STATUS_V2 = "store/admin/v2/products/status",
    IMPORT_PRODUCT = "store/admin/product/import",

    // Admin API v3 (I18nLabel completo + identidad estable de opciones/valores/variantes).
    // Usados solo por el form de detalle de producto (crear/editar); el listado/búsqueda y los
    // widgets que solo necesitan mostrar un título siguen en v2 (ver product.service.ts).
    CREATE_PRODUCT_V3 = "store/admin/v3/product",
    UPDATE_PRODUCT_V3 = "store/admin/v3/product",
    GET_PRODUCT_BY_ID_V3 = "store/admin/v3/product/",
    BULK_EDIT_PREVIEW_V3 = "store/admin/v3/products/bulk-edit/preview",
    BULK_EDIT_APPLY_V3 = "store/admin/v3/products/bulk-edit",
    BULK_EDIT_PLANS_V3 = "store/admin/v3/products/bulk-edit/plans",

    // F0-5 (D6, doc/multilanguages_products_cateogires/multi-language-architecture.md §6.5):
    // aviso de carritos vivos antes de un cambio de dimensión de variantes.
    IMPACT_CHECK_V3 = "store/admin/v3/product/impact-check",

    // Genera códigos de barras internos (EAN-13, prefijo 20-29) libres en el site. No persiste
    // nada: los códigos llegan a base de datos al guardar el producto que los lleva.
    GENERATE_BARCODE_V3 = "store/admin/v3/product/barcode/generate",
}
